<script lang="ts">
    import {getLocalization} from 'src/core';
    import {getRichtextAreaContext} from '../../richtext-area.context';
    import {get} from 'svelte/store';
    import {exists} from 'shared/utils/custom-utils';
    import {callCommand} from '@milkdown/utils';
    import {toggleStrongCommand} from '@milkdown/preset-commonmark';
    import ToolbarButton from './ToolbarButton.svelte';

    const {editor$} = getRichtextAreaContext();
    const localize = getLocalization();

    function toggleBold() {
        const editor = get(editor$);
        if (!exists(editor)) {
            return;
        }

        editor.action(
            callCommand(toggleStrongCommand.key)
        );
    }
</script>

<ToolbarButton icon="bold"
               tooltipLabel={localize(/* @kp-localization richTextArea.tools.bold */ 'richTextArea.tools.bold')}
               on:click={toggleBold}/>